import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const AlphabetStyled = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings['200']};
  cursor: pointer;
`;
export const AlphabetListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  px: { sm: '300' },
  py: { sm: '400' },
})``;
